import { render } from "./SbpIcon.vue?vue&type=template&id=4b3a5708"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/SbpIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b3a5708"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b3a5708', __exports__)) {
    api.reload('4b3a5708', __exports__)
  }
  
  module.hot.accept("./SbpIcon.vue?vue&type=template&id=4b3a5708", () => {
    api.rerender('4b3a5708', render)
  })

}


export default __exports__